import { ref, type Ref } from "vue";
import type FormCC from "@/interface/FormCC";
import MasterService from "@/service/restfulService/CCOnboardMasterService";
import type UploadFileValidity from "@/interface/UploadFileValidity";
import type MultiChannelLink from "@/interface/MultiChannelLink";

export default function uploadDocumentsSubmit(
  ccFormValue: Ref<FormCC>,
  prop: any,
  page8Overlay: Ref<boolean>,
  isTimeOut: Ref<boolean>,
  isSessionEnd: Ref<boolean>,
  status: Ref<string>,
  uploadFileValidity: Ref<UploadFileValidity>,
  multiChannel: Ref<MultiChannelLink>,
  jumpStep: (value: number, name: string, page: string) => void,
  getProductStepFromBackend: (
    forward: boolean,
    backward: boolean,
    resume: boolean,
    autoPopulated: boolean,
    summaryEditBtn: string,
  ) => void,
  resumeBundleType: Ref<string>,
): void {
  isTimeOut.value = false;
  page8Overlay.value = true;
  if (
    uploadFileValidity.value.uploadFile1 == "invalidFileType" ||
    uploadFileValidity.value.uploadFile1 == "EC002"
  ) {
    uploadFileValidity.value.uploadFile1 = "";
  }
  if (
    uploadFileValidity.value.uploadFile2 == "invalidFileType" ||
    uploadFileValidity.value.uploadFile2 == "EC002"
  ) {
    uploadFileValidity.value.uploadFile2 = "";
  }
  if (
    uploadFileValidity.value.uploadFile4 == "invalidFileType" ||
    uploadFileValidity.value.uploadFile4 == "EC002"
  ) {
    uploadFileValidity.value.uploadFile4 = "";
  }
  const requestModel = {
    webFormRequestId: ccFormValue.value.webFormRequestId,
    suppFormRequestId: "",
    documentNameDTO: {
      proofOfIdentityFileName:
        ccFormValue.value.uploadDocument.proofIdentity.resumeDeletedFile
          .concat(
            ccFormValue.value.MosUploadDocument.proofIdentity.resumeDeletedFile,
          )
          .concat(
            ccFormValue.value.EPCCUploadDocument.proofIdentity
              .resumeDeletedFile,
          ),
      proofOfIncomeFileName:
        ccFormValue.value.uploadDocument.proofIncome.resumeDeletedFile
          .concat(
            ccFormValue.value.MosUploadDocument.proofIncome.resumeDeletedFile,
          )
          .concat(
            ccFormValue.value.EPCCUploadDocument.proofIncome.resumeDeletedFile,
          ),
      proofOfJCKLFileName:
        ccFormValue.value.uploadDocument.proofJCKL.resumeDeletedFile,
    },
  };
  MasterService.docCheck(requestModel, ccFormValue.value.token)
    .then((res) => {
      if (res.status == 200) {
        MasterService.docSubmit(ccFormValue.value, ccFormValue.value.token)
          .then((res) => {
            if (res.status == 200) {
              // Invalid File Type
              if (res.data.responseModel.status == "EC001") {
                page8Overlay.value = false;
                isTimeOut.value = true;

                // principal identity file
                if (
                  res.data.responseModel.documentNameDTO
                    .proofOfIdentityFileName &&
                  res.data.responseModel.documentNameDTO.proofOfIdentityFileName
                    .length != 0
                ) {
                  for (
                    let i = 0;
                    i <
                    res.data.responseModel.documentNameDTO
                      .proofOfIdentityFileName.length;
                    i++
                  ) {
                    for (
                      let j = 0;
                      j <
                      ccFormValue.value.uploadDocument.proofIdentity.fileName
                        .length;
                      j++
                    ) {
                      if (
                        res.data.responseModel.documentNameDTO
                          .proofOfIdentityFileName[i] ==
                        ccFormValue.value.uploadDocument.proofIdentity.fileName[
                          j
                        ]
                      ) {
                        ccFormValue.value.uploadDocument.proofIdentity.invalidFile[
                          j
                        ] = true;
                        uploadFileValidity.value.uploadFile1 =
                          res.data.responseModel.status;
                      }
                    }
                  }
                }

                // principal income file
                if (
                  res.data.responseModel.documentNameDTO
                    .proofOfIncomeFileName &&
                  res.data.responseModel.documentNameDTO.proofOfIncomeFileName
                    .length != 0
                ) {
                  for (
                    let i = 0;
                    i <
                    res.data.responseModel.documentNameDTO.proofOfIncomeFileName
                      .length;
                    i++
                  ) {
                    for (
                      let j = 0;
                      j <
                      ccFormValue.value.uploadDocument.proofIncome.fileName
                        .length;
                      j++
                    ) {
                      if (
                        res.data.responseModel.documentNameDTO
                          .proofOfIncomeFileName[i] ==
                        ccFormValue.value.uploadDocument.proofIncome.fileName[j]
                      ) {
                        ccFormValue.value.uploadDocument.proofIncome.invalidFile[
                          j
                        ] = true;
                        uploadFileValidity.value.uploadFile2 =
                          res.data.responseModel.status;
                      }
                    }
                  }
                }

                //jckl file
                if (
                  res.data.responseModel.documentNameDTO.proofOfJCKLFileName &&
                  res.data.responseModel.documentNameDTO.proofOfJCKLFileName
                    .length != 0
                ) {
                  for (
                    let i = 0;
                    i <
                    res.data.responseModel.documentNameDTO.proofOfJCKLFileName
                      .length;
                    i++
                  ) {
                    for (
                      let j = 0;
                      j <
                      ccFormValue.value.uploadDocument.proofJCKL.fileName
                        .length;
                      j++
                    ) {
                      if (
                        res.data.responseModel.documentNameDTO
                          .proofOfJCKLFileName[i] ==
                        ccFormValue.value.uploadDocument.proofJCKL.fileName[j]
                      ) {
                        ccFormValue.value.uploadDocument.proofJCKL.invalidFile[
                          j
                        ] = true;
                        uploadFileValidity.value.uploadFile4 =
                          res.data.responseModel.status;
                      }
                    }
                  }
                }
                return;
              }
              // Malicious File
              else if (res.data.responseModel.status == "EC002") {
                page8Overlay.value = false;
                isTimeOut.value = true;

                // principal identity file
                if (
                  res.data.responseModel.documentNameDTO
                    .proofOfIdentityFileName &&
                  res.data.responseModel.documentNameDTO.proofOfIdentityFileName
                    .length != 0
                ) {
                  const deletedNames: string[] = [];
                  for (
                    let i = 0;
                    i <
                    res.data.responseModel.documentNameDTO
                      .proofOfIdentityFileName.length;
                    i++
                  ) {
                    for (
                      let j =
                        ccFormValue.value.uploadDocument.proofIdentity.fileName
                          .length - 1;
                      j >= 0;
                      j--
                    ) {
                      if (
                        res.data.responseModel.documentNameDTO
                          .proofOfIdentityFileName[i] ==
                        ccFormValue.value.uploadDocument.proofIdentity.fileName[
                          j
                        ]
                      ) {
                        deletedNames.push(
                          ccFormValue.value.uploadDocument.proofIdentity
                            .fileName[j],
                        );
                        ccFormValue.value.uploadDocument.proofIdentity.fileName.splice(
                          j,
                          1,
                        );
                        ccFormValue.value.uploadDocument.proofIdentity.file.splice(
                          j,
                          1,
                        );
                        ccFormValue.value.uploadDocument.proofIdentity.fileNumber =
                          ccFormValue.value.uploadDocument.proofIdentity.fileName.length;
                      }
                    }
                  }
                  if (deletedNames.length > 0) {
                    uploadFileValidity.value.uploadFile1 = "EC002";
                    uploadFileValidity.value.maliciousFile1Names = deletedNames;
                  }
                }

                // principal income file
                if (
                  res.data.responseModel.documentNameDTO
                    .proofOfIncomeFileName &&
                  res.data.responseModel.documentNameDTO.proofOfIncomeFileName
                    .length != 0
                ) {
                  const deletedNames: string[] = [];
                  for (
                    let i = 0;
                    i <
                    res.data.responseModel.documentNameDTO.proofOfIncomeFileName
                      .length;
                    i++
                  ) {
                    for (
                      let j =
                        ccFormValue.value.uploadDocument.proofIncome.fileName
                          .length - 1;
                      j >= 0;
                      j--
                    ) {
                      if (
                        res.data.responseModel.documentNameDTO
                          .proofOfIncomeFileName[i] ==
                        ccFormValue.value.uploadDocument.proofIncome.fileName[j]
                      ) {
                        deletedNames.push(
                          ccFormValue.value.uploadDocument.proofIncome.fileName[
                            j
                          ],
                        );
                        ccFormValue.value.uploadDocument.proofIncome.fileName.splice(
                          j,
                          1,
                        );
                        ccFormValue.value.uploadDocument.proofIncome.file.splice(
                          j,
                          1,
                        );
                        ccFormValue.value.uploadDocument.proofIncome.fileNumber =
                          ccFormValue.value.uploadDocument.proofIncome.fileName.length;
                      }
                    }
                  }
                  if (deletedNames.length > 0) {
                    uploadFileValidity.value.uploadFile2 = "EC002";
                    uploadFileValidity.value.maliciousFile2Names = deletedNames;
                  }
                }

                // jckl file
                if (
                  res.data.responseModel.documentNameDTO.proofOfJCKLFileName &&
                  res.data.responseModel.documentNameDTO.proofOfJCKLFileName
                    .length != 0
                ) {
                  const deletedNames: string[] = [];
                  for (
                    let i = 0;
                    i <
                    res.data.responseModel.documentNameDTO.proofOfJCKLFileName
                      .length;
                    i++
                  ) {
                    for (
                      let j =
                        ccFormValue.value.uploadDocument.proofJCKL.fileName
                          .length - 1;
                      j >= 0;
                      j--
                    ) {
                      if (
                        res.data.responseModel.documentNameDTO
                          .proofOfJCKLFileName[i] ==
                        ccFormValue.value.uploadDocument.proofJCKL.fileName[j]
                      ) {
                        deletedNames.push(
                          ccFormValue.value.uploadDocument.proofJCKL.fileName[
                            j
                          ],
                        );
                        ccFormValue.value.uploadDocument.proofJCKL.fileName.splice(
                          j,
                          1,
                        );
                        ccFormValue.value.uploadDocument.proofJCKL.file.splice(
                          j,
                          1,
                        );
                        ccFormValue.value.uploadDocument.proofJCKL.fileNumber =
                          ccFormValue.value.uploadDocument.proofJCKL.fileName.length;
                      }
                    }
                  }
                  if (deletedNames.length > 0) {
                    uploadFileValidity.value.uploadFile4 = "EC002";
                    uploadFileValidity.value.maliciousFile4Names = deletedNames;
                  }
                }

                return;
              } else {
                if (ccFormValue.value.isDraft) {
                  const newFormData = new FormData();
                  newFormData.append("", "");
                  ccFormValue.value.uploadDocument.proofIdentity.file = [];
                  ccFormValue.value.uploadDocument.proofIncome.file = [];
                  ccFormValue.value.uploadDocument.proofJCKL.file = [];
                  if (res.data.responseModel.documentNameDTO) {
                    if (
                      res.data.responseModel.documentNameDTO
                        .proofOfIdentityFileName.length > 0
                    ) {
                      ccFormValue.value.uploadDocument.proofIdentity.fileName =
                        [];
                      for (
                        let i = 0;
                        i <
                        res.data.responseModel.documentNameDTO
                          .proofOfIdentityFileName.length;
                        i++
                      ) {
                        ccFormValue.value.uploadDocument.proofIdentity.fileName.push(
                          res.data.responseModel.documentNameDTO
                            .proofOfIdentityFileName[i],
                        );
                        ccFormValue.value.uploadDocument.proofIdentity.file.push(
                          newFormData,
                        );
                      }
                      ccFormValue.value.uploadDocument.proofIdentity.resumeFileNumber =
                        res.data.responseModel.documentNameDTO.proofOfIdentityFileName.length;
                    }

                    if (
                      res.data.responseModel.documentNameDTO
                        .proofOfIncomeFileName.length > 0
                    ) {
                      ccFormValue.value.uploadDocument.proofIncome.fileName =
                        [];
                      for (
                        let i = 0;
                        i <
                        res.data.responseModel.documentNameDTO
                          .proofOfIncomeFileName.length;
                        i++
                      ) {
                        ccFormValue.value.uploadDocument.proofIncome.fileName.push(
                          res.data.responseModel.documentNameDTO
                            .proofOfIncomeFileName[i],
                        );
                        ccFormValue.value.uploadDocument.proofIncome.file.push(
                          newFormData,
                        );
                      }
                      ccFormValue.value.uploadDocument.proofIncome.resumeFileNumber =
                        res.data.responseModel.documentNameDTO.proofOfIncomeFileName.length;
                    }

                    if (
                      res.data.responseModel.documentNameDTO.proofOfJCKLFileName
                        .length > 0
                    ) {
                      ccFormValue.value.uploadDocument.proofJCKL.fileName = [];
                      for (
                        let i = 0;
                        i <
                        res.data.responseModel.documentNameDTO
                          .proofOfJCKLFileName.length;
                        i++
                      ) {
                        ccFormValue.value.uploadDocument.proofJCKL.fileName.push(
                          res.data.responseModel.documentNameDTO
                            .proofOfJCKLFileName[i],
                        );
                        ccFormValue.value.uploadDocument.proofJCKL.file.push(
                          newFormData,
                        );
                      }
                      ccFormValue.value.uploadDocument.proofJCKL.resumeFileNumber =
                        res.data.responseModel.documentNameDTO.proofOfJCKLFileName.length;
                    }
                  }
                }

                isTimeOut.value = true;
                if (
                  ccFormValue.value.summarySetting.uploadDocumentsJump == true
                ) {
                  ccFormValue.value.summarySetting.uploadDocumentsJump = false;
                  ccFormValue.value.summarySetting.employmentDetailsJump = false;
                  //TODO-Matrix
                  if (
                    prop.type == "PF_CC" ||
                    prop.type == "EP_CC" ||
                    resumeBundleType.value == "PF_CC" ||
                    resumeBundleType.value == "EP_CC"
                  ) {
                    getProductStepFromBackend(
                      false,
                      false,
                      false,
                      false,
                      "Summary",
                    );
                  } else {
                    jumpStep(12, "", "8");
                  }
                  page8Overlay.value = false;
                } else {
                  ccFormValue.value.imageFilePath =
                    res.data.responseModel.imageFilePath;
                  page8Overlay.value = false;
                  status.value = "N";
                  ccFormValue.value.dropOffStep = 9;
                  if (
                    prop.type == "PF_CC" ||
                    prop.type == "EP_CC" ||
                    resumeBundleType.value == "PF_CC" ||
                    resumeBundleType.value == "EP_CC" ||
                    multiChannel.value.acc == "M1" ||
                    multiChannel.value.acc == "M7"
                  ) {
                    const requestModel2 = {
                      webFormRequestId: ccFormValue.value.webFormRequestId,
                      webFormDetails: {
                        supp: {
                          isSupp: "No",
                        },
                      },
                    };
                    MasterService.pageSubmit(
                      requestModel2,
                      ccFormValue.value.token,
                    )
                      .then((res) => {
                        if (res.status == 200) {
                          //TODO-Matrix
                          if (
                            prop.type == "PF_CC" ||
                            prop.type == "EP_CC" ||
                            resumeBundleType.value == "PF_CC" ||
                            resumeBundleType.value == "EP_CC"
                          ) {
                            getProductStepFromBackend(
                              true,
                              false,
                              false,
                              false,
                              "",
                            );
                          } else {
                            jumpStep(12, "", "8");
                          }
                        }
                      })
                      .catch((e) => {
                        if (e.response.data.code == "WB-401") {
                          // EndSession
                          isTimeOut.value = false;
                          isSessionEnd.value = true;
                        }
                      });
                  } else jumpStep(9, "", "8");
                }
              }
            } else {
              page8Overlay.value = false;
              status.value = "F";
            }
          })
          .catch((e) => {
            if (e.response && e.response.data.code == "WB-401") {
              // EndSession
              isTimeOut.value = false;
              isSessionEnd.value = true;
            }
            page8Overlay.value = false;
            isTimeOut.value = true;
          });
      }
    })
    .catch((e) => {
      if (e.response && e.response.data.code == "WB-401") {
        // EndSession
        isTimeOut.value = false;
        isSessionEnd.value = true;
      }
      page8Overlay.value = false;
      isTimeOut.value = true;
    });
}
